var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"ma-2"},[_vm._v("\n    สร้างบริการคอร์ส\n  ")]),_c('v-container',[_c('course-form',{attrs:{"services":_vm.services,"form-data":_vm.formData},on:{"submit":_vm.editCourse}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }